import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  UseModalProps,
} from "@chakra-ui/modal";
import {
  Button,
  FormControl,
  FormLabel,
  ModalBody,
  ModalFooter,
  ThemingProps,
} from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import React, { useEffect, useState } from "react";
import { useAdminApiRequest } from "../../hooks/useApiRequest";

export type CherryPayCardFilterType = {
  businessId?: string;
  externalAccountId?: string;
};

interface CherryPayCardFilterModalProps {
  isOpen: boolean;
  filter?: CherryPayCardFilterType;
  onSuccess: (filter?: CherryPayCardFilterType) => void;
  onClose: () => void;
}

type BusinessOption = { value: string; label: string };

export const CherryPayCardFilterModal = ({
  isOpen,
  filter,
  onSuccess,
  onClose,
  ...modalProps
}: CherryPayCardFilterModalProps & UseModalProps & ThemingProps<"Modal">) => {
  const [selectedOption, setSelectedOption] = useState<
    BusinessOption | null | undefined
  >(null);

  const { data: businessesResult, isLoading: businessesLoading } =
    useAdminApiRequest((api) => api.getBusinesses(undefined, 500), []);

  const businessOptions: BusinessOption[] =
    businessesResult?.Results?.map(
      (b: { Meta?: { Id?: string | null }; DisplayName?: string | null }) => ({
        value: b.Meta?.Id ?? "",
        label: `${b.DisplayName ?? b.Meta?.Id ?? ""} (${b.Meta?.Id ?? ""})`,
      })
    ).filter((o: BusinessOption) => o.value) ?? [];

  useEffect(() => {
    if (isOpen) {
      if (filter?.businessId) {
        const match = businessOptions.find(
          (o) => o.value === filter.businessId
        );
        setSelectedOption(
          match ?? { value: filter.businessId, label: filter.businessId }
        );
      } else {
        setSelectedOption(null);
      }
    }
  }, [isOpen, filter?.businessId]);

  const handleApply = () => {
    onSuccess({
      businessId: selectedOption?.value,
      externalAccountId: filter?.externalAccountId,
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...modalProps}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>CherryPay Cards Filter</ModalHeader>
        <ModalBody>
          <FormControl>
            <FormLabel>Business</FormLabel>
            <Select<BusinessOption>
              isClearable
              isLoading={businessesLoading}
              options={businessOptions}
              placeholder="All businesses"
              value={selectedOption}
              onChange={(opt) => setSelectedOption(opt ?? null)}
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="cherryButton" onClick={handleApply}>
            Apply
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
